import { useCallback } from 'react';

import type { IUseIncludeExcludeWorkOrderObjects, IUseIncludeExcludeWorkOrderObjectsResult } from '../types';
import { WorkOrderStructureOperationType } from '../types';

export const useIncludeExcludeWorkOrderObjects = (
    props: IUseIncludeExcludeWorkOrderObjects,
): IUseIncludeExcludeWorkOrderObjectsResult => {
    const {
        workOrderId,
        constructionTypeId,
        useIncludeExcludeWorkOrderObjectsData,
        updateIncludedCount,
        checkedIds,
        setCheckedIds,
    } = props;

    const onSuccess = useCallback(
        (operation: WorkOrderStructureOperationType, result: number[]) => {
            if (!constructionTypeId) {
                return;
            }

            if (operation === WorkOrderStructureOperationType.IncludeAll) {
                setCheckedIds(result);
                updateIncludedCount(constructionTypeId, result.length, true);
            }

            if (operation === WorkOrderStructureOperationType.ExcludeAll) {
                setCheckedIds([]);
                updateIncludedCount(constructionTypeId, 0, true);
            }

            if (operation === WorkOrderStructureOperationType.Include) {
                setCheckedIds([...checkedIds, ...result]);
                updateIncludedCount(constructionTypeId, result.length);
            }

            if (operation === WorkOrderStructureOperationType.Exclude) {
                setCheckedIds(checkedIds.filter((id) => !result.includes(id)));
                updateIncludedCount(constructionTypeId, -result.length);
            }
        },
        [checkedIds, constructionTypeId, setCheckedIds, updateIncludedCount],
    );

    const { makeRequest, status } =
        useIncludeExcludeWorkOrderObjectsData?.({
            workOrderOrChangeId: workOrderId,
            constructionTypeId,
            onSuccess,
        }) || {};

    return {
        includeExcludeStatus: status,
        makeIncludeExcludeRequest: makeRequest,
    };
};
